export default defineNuxtPlugin(() => {
  const podeliScript = document.createElement('script')

  podeliScript.src =
    'https://cdn.podeli.ru/New-Widgets/ReactWidget/widget-podeli.js'
  podeliScript.defer = true

  document.body.appendChild(podeliScript)
})
